import { useContext } from 'react';

import type { Announce } from '../Announcer';
import AnnouncerContext from '../AnnouncerContext';

type UseAnnouncer = () => Announce;
// @deprecated For announcements in the UI layer, use FUI9 useAnnounce hook, or useAnnounceCallback wrapper
export const useAnnouncer: UseAnnouncer = () => useContext(AnnouncerContext).announce;
